import {Injectable} from '@angular/core';
import {CourseContentStructure, CourseStructureNode} from './create-courses/store/course.model';
import {number} from 'echarts';
import { Router, ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CourseHelperServiceService {

  constructor(private router: Router, private route: ActivatedRoute) {
  }


  toggleIsEditingAtLevel(
    structure: any[],
    lvl: number,
    indices: { parentIndex?: number; childIndex?: number; grandChildIndex?: number },
    nodeType: number,
    contentIndex?: number,
    toggleType: 'edit' | 'visible' = 'edit'
  ): any[] {
    const updatedStructure = [...structure];

    const {parentIndex, childIndex, grandChildIndex} = indices;

    const getNode = () => {
      if (lvl === 1) return updatedStructure[parentIndex!];
      if (lvl === 2) return updatedStructure[parentIndex!]?.child?.[childIndex!];
      if (lvl === 3) return updatedStructure[parentIndex!]?.child?.[childIndex!]?.grandChild?.[grandChildIndex!];
    };

    const setNode = (newNode: any) => {
      if (lvl === 1) {
        updatedStructure[parentIndex!] = newNode;
      } else if (lvl === 2) {
        const parent = {...updatedStructure[parentIndex!]};
        const updatedChild = [...parent.child];
        updatedChild[childIndex!] = newNode;
        parent.child = updatedChild;
        updatedStructure[parentIndex!] = parent;
      } else if (lvl === 3) {
        const parent = {...updatedStructure[parentIndex!]};
        const child = {...parent.child[childIndex!]};
        const updatedGrandChild = [...child.grandChild];
        updatedGrandChild[grandChildIndex!] = newNode;
        child.grandChild = updatedGrandChild;
        parent.child = [...parent.child];
        parent.child[childIndex!] = child;
        updatedStructure[parentIndex!] = parent;
      }
    };

    const node = getNode();
    if (!node) return updatedStructure;

    if (nodeType === 1) {
      if (toggleType === 'edit') {
        setNode({...node, isEditing: !node.isEditing});
        // node.isEditing = !node.isEditing;
      } else if (toggleType === 'visible') {
        setNode({...node, isOpen: !node.isOpen});
        // node.isOpen = !node.isOpen;
      }
    } else if (nodeType === 2 && contentIndex != null) {
      const maps = [...node.structure_maps];
      const map = maps[contentIndex];
      if (map?.action_type === 'video') {
        maps[contentIndex] = {
          ...map,
          video: {
            ...map.video,
            isEditing: !map.video?.isEditing,
          },
        };
        setNode({...node, structure_maps: maps});
      }
    }

    return updatedStructure;
  }

  addCourseNode(
    structure: CourseStructureNode[],
    lvl: number,
    data: CourseStructureNode,
    parentId?: string | number | null,
    childId?: string | number | null
  ) {
    console.log(structure);

    // Level 1: Add directly to root
    if (lvl === 1) {
      return [...(structure || []), data]
    }

    const updatedData = (structure || []).map(parentNode => {
      // Handle level 2
      if (lvl === 2 && parentNode.id === Number(parentId)) {
        return {
          ...parentNode,
          child: [...(parentNode.child || []), data],
        };
      }

      // Handle level 3
      if (lvl === 3 && parentNode.id === Number(parentId)) {
        return {
          ...parentNode,
          child: parentNode.child?.map(childNode => {
            if (childNode.id === Number(childId)) {
              return {
                ...childNode,
                grandChild: [...(childNode.grandChild || []), data],
              };
            }
            return childNode;
          }),
        };
      }

      return parentNode;
    });

    return updatedData
  }


  deleteNewNode(
    structure: CourseStructureNode[],
    lvl: number,
    id: number,
    parentIndex?: number,
    childIndex?: number,
    grandChildIndex?: number
  ): CourseStructureNode[] {
    const updated = [...structure];

    // Level 1 deletion (from root)
    if (lvl === 1 && parentIndex !== undefined) {
      if (updated[parentIndex]?.id === id) {
        updated.splice(parentIndex, 1);
      }
      return updated;
    }

    // Level 2 deletion (child inside root)
    if (lvl === 2 && parentIndex !== undefined && childIndex !== undefined) {
      const parent = updated[parentIndex];
      if (parent?.child?.[childIndex]?.id === id) {
        parent.child.splice(childIndex, 1);
      }
      return updated;
    }

    // Level 3 deletion (grandChild inside child)
    if (
      lvl === 3 &&
      parentIndex !== undefined &&
      childIndex !== undefined &&
      grandChildIndex !== undefined
    ) {
      const parent = updated[parentIndex];
      const child = parent?.child?.[childIndex];
      if (child?.grandChild?.[grandChildIndex]?.id === id) {
        child.grandChild.splice(grandChildIndex, 1);
      }
      return updated;
    }

    return updated; // No changes if not matched
  }




  addStructureNode(
    structure: CourseStructureNode[],
    lvl: number,
    data: any,
    parentId: string | number,
    childId?: string | number | null,
    grandChildId?: string | number | null,
  ) {
    const updatedData = (structure || []).map(parentNode => {
      if (lvl === 1 && parentNode.id === Number(parentId)) {
        return {
          ...parentNode,
          structure_maps: [...(parentNode.structure_maps || []), data],
        };
      }

      if (lvl === 2 && parentNode.id === Number(parentId)) {
        return {
          ...parentNode,
          child: parentNode.child?.map(childNode => {
            if (childNode.id === Number(childId)) {
              return {
                ...childNode,
                structure_maps: [...(childNode.structure_maps || []), data],
              };
            }
            return childNode;
          })
        };
      }

      if (lvl === 3 && parentNode.id === Number(parentId)) {
        return {
          ...parentNode,
          child: parentNode.child?.map(childNode => {
            if (childNode.id === Number(childId)) {
              return {
                ...childNode,
                grandChild: childNode.grandChild?.map(grandChildNode => {
                  if (grandChildNode.id === Number(grandChildId)) {
                    return {
                      ...grandChildNode,
                      structure_maps: [...(grandChildNode.structure_maps || []), data],
                    };
                  }
                  return grandChildNode;
                })
              };
            }
            return childNode;
          })
        };
      }

      return parentNode;
    });

    return updatedData
  }

deleteStructureMap(
  structure: CourseStructureNode[],
  indexInfo: {
    parentIndex: number;
    childIndex?: number;
    grandChildIndex?: number;
    structureIndex: number;
  }
): CourseStructureNode[] {
  const { parentIndex, childIndex, grandChildIndex, structureIndex } = indexInfo;

  return structure.map((parentNode, pi) => {
    if (pi !== parentIndex) return parentNode;

    // GrandChild level
    if (childIndex != null && grandChildIndex != null) {
      const updatedGrandChild = parentNode.child?.[childIndex]?.grandChild?.map((gc, gci) => {
        if (gci !== grandChildIndex) return gc;
        return {
          ...gc,
          structure_maps: gc.structure_maps?.filter((_, si) => si !== structureIndex) || []
        };
      });

      return {
        ...parentNode,
        child: parentNode.child?.map((child, ci) => {
          if (ci !== childIndex) return child;
          return {
            ...child,
            grandChild: updatedGrandChild
          };
        })
      };
    }

    // Child level
    if (childIndex != null) {
      return {
        ...parentNode,
        child: parentNode.child?.map((child, ci) => {
          if (ci !== childIndex) return child;
          return {
            ...child,
            structure_maps: child.structure_maps?.filter((_, si) => si !== structureIndex) || []
          };
        })
      };
    }

    // Parent level
    return {
      ...parentNode,
      structure_maps: parentNode.structure_maps?.filter((_, si) => si !== structureIndex) || []
    };
  });
}




  toArray(value: any): any[] {
    if (Array.isArray(value)) {
      return value;
    }
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  nextTab(queryTab: string){
    this.router.navigate([], {
    relativeTo: this.route,
    queryParams: { tab: queryTab },
    queryParamsHandling: 'merge',
  });
  }


}
